import { de_DE } from 'ng-zorro-antd/i18n';

/** ng-zorro `de_DE` has no QRCode pack; the login QR logs Missing translations for "QRCode". */
export const nzDeDE = {
  ...de_DE,
  QRCode: {
    expired: 'QR-Code abgelaufen',
    refresh: 'Aktualisieren',
    scanned: 'Gescannt'
  }
};
